import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class VisaButtonModel extends ButtonBase {
    label: string = 'Visa';
    action: string = ACTION_STATUS.visa;
    matIconName: string = 'admin_panel_settings';
    colorClass: string = 'color-info-500';
}